import { RootState } from "src/app/model/store";

export const selectEmail = (state: RootState) => {
  return state.auth.email;
};

export const selectPassword = (state: RootState) => {
  return state.auth.password;
};

export const selectPasswordVisibility = (state: RootState) => {
  return state.auth.passwordVisible;
};

export const selectRememberChecked = (state: RootState) => {
  return state.auth.rememberChecked;
};

export const selectIsAuth = (state: RootState) => {
  return state.auth.isAuth;
};

export const selectError = (state: RootState) => {
  return state.auth.error;
};

export const selectIsLoading = (state: RootState) => {
  return state.auth.isLoading;
};
